import { APP_LAUNCH, mutationFetch } from "@atlas/sdk";
import type { UseMutationOptions } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

export interface IAppLaunchRequest {
  launchUrl: string;
  solutionId?: string;
  appMapId?: string;
}

/** API returns HTML with an auto-submitting SSO form. We return the raw HTML string. */
export const appLaunch = async (
  request: IAppLaunchRequest,
  basePath?: string,
): Promise<string> => {
  const path = APP_LAUNCH;
  const url = basePath ? `${basePath.replace(/\/$/, "")}${path}` : path;
  return mutationFetch<string>({
    url,
    method: "POST",
    body: request,
    responseType: "text",
  });
};

export const useAppLaunch = (
  basePath?: string,
  options?: Partial<
    UseMutationOptions<string, AxiosError, IAppLaunchRequest, unknown>
  >,
) => {
  return useMutation({
    mutationFn: (request: IAppLaunchRequest) => appLaunch(request, basePath),
    ...options,
  });
};
